import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
/* import SearchSelect from "../Search/Search"; */

import SelectLanguages from "../Language/Language";
import { ReactComponent as Lenguage } from "Assets/icons/icon-language.svg";
/* import { ReactComponent as Search } from "Assets/icons/icon-search.svg"; */
import Bars from "Assets/images/icon-bars-nav.png";
import Cross from "Assets/icons/icon-cross-nav.png";
import Logo from "Assets/images/Logo-sin-slogan.png";
import Baipro from "Assets/images/Logo_baipro.png";

import { ClickAwayListener } from "@mui/base";

import { useTranslation } from "react-i18next";

import { useAppSelector } from "Hooks/useRedux";
import { useAppDispatch } from "Hooks/useRedux";
import { logout } from "Redux/authSlice";
import { useScrollToElement } from "Hooks/useScrollToElement";
import { trackEvent } from "Services/Analytics/trackEvent";
import { useNavigate } from "react-router-dom";

import "./Navbar.scss";

type NavbarProps = {
  onChange: Function;
  isMobile: Boolean;
  scroll: number;
};

const Navbar: React.FC<NavbarProps> = ({ isMobile, scroll }: NavbarProps) => {
  const { t } = useTranslation();
  const [openLanguage, setOpenLanguage] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const location = window.location.pathname;
  const { scrollToElement } = useScrollToElement();
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setOpenMenu(false);
    }
  };

  useEffect(() => {
    setOpenMenu(false);
  }, [location]);

  useEffect(() => {
    if (openMenu) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    // Limpieza
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openMenu]);

  /* const [openSearch, setOpenSearch] = useState(false); */

  const isAuthenticated = Boolean(useAppSelector((state) => state.auth.token));
  const role = useAppSelector((state) => state.auth.role);
  const dispatch = useAppDispatch();

  const handleOpenLanguage = () => {
    setOpenLanguage(!openLanguage);
  };
  /*   const handleOpenSearch = () => {
    setOpenSearch(!openSearch);
    setOpenLanguage(false);
  };

  const handleClickAway = () => {
    setOpenSearch(false);
  }; */
  const handleClickAwayLenguage = () => {
    setOpenLanguage(false);
  };

  const handleLogout = () => {
    if (isAuthenticated) {
      dispatch(logout());
    } else {
      trackEvent("login_button");
    }
  };

  return (
    <>
      {isMobile ? (
        <>
          <nav className="NavMobile" ref={menuRef}>
            <div className="NavMobile-left">
              <NavLink to="/">
                <img
                  width={40}
                  height={40}
                  src={Logo}
                  alt="Logo de baipro"
                  className="NavMobile-left__Logo"
                />
              </NavLink>
              <NavLink to="/">
                <img
                  width={24}
                  height={24}
                  src={Baipro}
                  alt="Logo del texto"
                  className="NavMobile-left__logoText"
                />
              </NavLink>
            </div>

            <div className="NavMobile-right">
              <button
                onClick={handleOpenLanguage}
                aria-label="lenguage"
                className="NavMobile-right__btnLenguage"
              >
                <Lenguage width={22} height={22} />
                {openLanguage && <SelectLanguages />}
              </button>

              <button
                type="button"
                className="navBaipro_hamburger"
                aria-label="navbar"
                onClick={() => setOpenMenu(!openMenu)}
              >
                <img
                  src={openMenu ? Cross : Bars}
                  width={24}
                  height={24}
                  alt="toggle menu"
                />
              </button>
            </div>

            {openMenu && (
              <ul className="NavMobile-list">
                <li onClick={() => navigate("/services")}>
                  {t("header.services")}
                </li>
                <li onClick={() => navigate("/projects")}>
                  {t("header.projects")}
                </li>
                <li onClick={() => navigate("/about")}>{t("header.about")}</li>
                <li onClick={() => navigate("/environment")}>
                  {t("header.sustainability")}
                </li>
                <li
                  onClick={() => {
                    trackEvent("carreras_click");
                    navigate("/careers");
                  }}
                >
                  {t("header.careers")}
                </li>
                <li
                  onClick={() => {
                    trackEvent("contacto_clic");
                    scrollToElement("/", "contact");
                    setOpenMenu(false);
                    navigate("/");
                  }}
                >
                  {t("header.contact")}
                </li>
                <hr className="hr" />
                <li
                  onClick={() => {
                    navigate(isAuthenticated ? "/" : "/login");
                    handleLogout();
                  }}
                >
                  <button className="btnLoginMobile">
                    {isAuthenticated ? "Cerrar sesión" : "Ingresar"}
                  </button>
                </li>
              </ul>
            )}
          </nav>
        </>
      ) : (
        <>
          <nav className="navBaipro">
            <div className="navBaipro-list">
              <NavLink
                to="/"
                onClick={() => window.scroll(0, 0)}
                className="navBaipro-list_logo"
              >
                <img src={Logo} width={40} height={40} alt="Logo de baipro" />
              </NavLink>
              <ul className="navBaipro-list_items">
                <li>
                  <NavLink to="/services">{t("header.services")}</NavLink>
                </li>
                <li>
                  <NavLink to="/projects">{t("header.projects")} </NavLink>
                </li>
                <li>
                  <NavLink to="/about">{t("header.about")} </NavLink>
                </li>
                <li>
                  <NavLink to="/environment">
                    {t("header.sustainability")}
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/careers">{t("header.careers")} </NavLink>
                </li>
                <li onClick={() => scrollToElement("/", "contact")}>
                  <NavLink to="/">{t("header.contact")} </NavLink>
                </li>
              </ul>
              <div className="nav-right">
                <div>
                  <ul className="login-button-container">
                    {isAuthenticated && (
                      <li>
                        <NavLink
                          to={
                            role === "marketing"
                              ? "/admin/marketing"
                              : "/admin/human-resources"
                          }
                        >
                          <span className="color-sky">Administrador</span>
                        </NavLink>
                      </li>
                    )}
                    <li>
                      <NavLink to={isAuthenticated ? "/" : "login"}>
                        <button
                          onClick={handleLogout}
                          className="navBaipro-list_btnLogin"
                        >
                          {isAuthenticated
                            ? t("header.logout")
                            : t("header.login")}
                        </button>
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div
                  className={
                    location === "/" && scroll < 50
                      ? "navBaipro-icon navBaipro-icon-white"
                      : "navBaipro-icon"
                  }
                >
                  <ClickAwayListener onClickAway={handleClickAwayLenguage}>
                    <div className="navBaipro-icon_languages">
                      <button
                        onClick={handleOpenLanguage}
                        aria-label="lenguage"
                      >
                        <Lenguage width={22} height={22} />
                        {openLanguage ? <SelectLanguages /> : null}
                      </button>
                    </div>
                  </ClickAwayListener>
                  {/* <ClickAwayListener
                    mouseEvent="onMouseDown"
                    touchEvent="onTouchStart"
                    onClickAway={handleClickAway}
                  >
                    <div className="navBaipro-icon_search">
                      <button onClick={handleOpenSearch} aria-label="Search">
                        <Search width={22} height={22} />
                        {openSearch ? <SearchSelect /> : null}
                      </button>
                    </div>
                  </ClickAwayListener> */}
                </div>
              </div>
            </div>
          </nav>
        </>
      )}
    </>
  );
};

export default Navbar;
